import React from "react";

function Share(props) {
  const links = [
    {
      id: 1,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd0s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5ea966304488c2f0fe459ab1_Frame%20100.png",
    },
    {
      id: 2,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd1s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5ea966428d96b38583769263_Frame%20101.png",
    },
    {
      id: 3,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd2s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5ea966b2536b870767af409a_Frame%20102.png",
    },
    {
      id: 4,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd3s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5ea6d5052e0b427f7cebedc7_Frame%20103.png",
    },
    {
      id: 5,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd4s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5eaf99ed6af9c84971e6c06d_4.png",
    },
    {
      id: 6,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd5s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5eaf9a04b8d39c39567b623f_5.png",
    },
    {
      id: 7,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd6s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5eaf9a17ab5c4ec5daeca6f9_6.png",
    },
    {
      id: 8,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd7s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5eaf9a2db41a948204c10909_7.png",
    },
    {
      id: 9,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd8s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5eaf9a56b8d39cb5687b634b_8.png",
    },
    {
      id: 10,
      shareUrl: "https://futuedu.com/excel-osaamistesti-haaste/6fd9s8y7hiu",
      shareImg:
        "https://uploads-ssl.webflow.com/5c77ee8b2417e4ae2211fc2d/5eaf9a67a0d3e4503d6dc460_9.png",
    },
  ];

  const link = links[props.score].shareUrl;
  const image = links[props.score].shareImg;
  const scorePercent = Math.round((props.score / props.totalQuestions) * 100);
  const email =
    "mailto:?subject=Osaan " +
    scorePercent +
    "% Excelistä. Kuinka pajon sinä osaa?&body=Kokeile kuinka paljon sinä osaat: " +
    link;
  const fb = "https://www.facebook.com/sharer/sharer.php?u=" + link;
  const whatsapp =
    "whatsapp://send?text=Osasin! " +
    scorePercent +
    "% Excelistä. Kuinka paljon sinä osaa? Kokeile: " +
    link;
  const signup = "https://app.futuedu.com/accounts/signup/";
  const tutustu = "https://futuedu.com/" + props.score;

  return (
    <>
      <div className="flex">
        <div className="flex-text left">
          <p className="paragraph-large">Excel-osaamistestisi tulos</p>
          <h3>Osaat {scorePercent}% Excelin tärkeistä ominaisuuksista</h3>
          <p className="text-large">
            Raapaisimme kuitenkin vasta pintaa. Tämä lyhyt testi sisälsi vain 9
            tärkeää Excel-ominaisuutta. Excelissä on kuitenkin satoja
            ominaisuuksia ja niistä noin 50 elintärkeitä kaikille
            Excel-käyttäjille.
          </p>
        </div>
        <div className="flex-text right">
          <div className="card-bg card-dark">
            <h3>Haluatko tietää tarkemmin mitä osaat?</h3>
            <p className="text-large">
              Selvitä ilmaiseksi kuinka paljon osaat Excelin 50 tärkeimmästä
              ominaisuudesta.
            </p>
            <p>
              <a
                href={signup}
                target="_blank"
                className="button w-button button-large"
              >
                Rekisteröidy ilmaiseksi
              </a>
            </p>
            <p>
              Tai{" "}
              <a href="/" target="_blank">
                tutustu Futueduun
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className="card-bg top-margin">
        <h3>Jaa tuloksesi ja haasta ystäväsi</h3>
        <div className="flex">
          <div className="flex-text left">
            <img src={image} className="share-image" alt=""></img>
          </div>
          <div className="flex-text left">
            <form action="">
              <div>
                <label htmlFor="">Kopioi linkki</label>
                <input type="text" className="share-input" value={link} />
                <label htmlFor="">Jaa suoraan</label>
                <a href={link} className="share-link">
                  linkki
                </a>
                <a href={email} className="share-link">
                  Email
                </a>
                <a href={fb} className="share-link">
                  facebook
                </a>
                <a
                  href={whatsapp}
                  data-action="share/whatsapp/share"
                  className="share-link"
                >
                  WhatsApp
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Share;
